import type { IkeUserRole, UserProfileJSONObject } from '@ikegps/core-api';
import { ModalFormComponent } from '../../components/modal.form/modal.form.component';
import { T, Translate } from '../../i18n/index';
import type { AccountsCtrl } from './accounts.ctrl';

const ACCOUNTS_SET_ROLE_SUCCESS = { key: T.ACCOUNTS_SET_ROLE_SUCCESS };

export class AccountsConfirmRole extends ModalFormComponent {
	ctrl: AccountsCtrl;
	user: UserProfileJSONObject;
	role: IkeUserRole;

	constructor(ctrl: AccountsCtrl, user: UserProfileJSONObject, role: IkeUserRole) {
		super({
			title: T.ACCOUNTS_SET_ROLE_TITLE,
			confirm: T.ACCOUNTS_SET_ROLE,
			success: ACCOUNTS_SET_ROLE_SUCCESS,
		});

		this.ctrl = ctrl;
		this.user = user;
		this.role = role;
	}

	get nodes() {
		const role = this.role === 'root' ? 'admin' : this.role;
		return Translate(T.ACCOUNTS_SET_ROLE_CONFIRM, { username: this.user.username, role }) as any;
	}

	override submit(): Promise<boolean> {
		return this.ctrl.setUserRole(this.user, this.role);
	}

	override failToChange() {
		this.ctrl.setLoading(this.user.objectId, false);
	}
}
